import { render, staticRenderFns } from "./KyyAppModalNewsSelector.vue?vue&type=template&id=57c8b80a&scoped=true&"
import script from "./KyyAppModalNewsSelector.vue?vue&type=script&lang=js&"
export * from "./KyyAppModalNewsSelector.vue?vue&type=script&lang=js&"
import style0 from "./KyyAppModalNewsSelector.vue?vue&type=style&index=0&id=57c8b80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c8b80a",
  null
  
)

export default component.exports